/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useState } from 'react';
import baseURL, { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import { PageHitCountApi } from '../../../shared/Helper';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { t } from 'i18next';
import { z } from 'zod';
import LoadingAnimation from '../../../components/LoadingAnimation';
import AddCartItem from '../../../components/cards/AddCartItem';
import Banners from '../../../components/elements/Banners';
import useFetch from '../../../hooks/useFetch/useFetch';
import axios from 'axios';

const AddCart = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [token, setToken] = useState(false);
  const [value, setValue] = useState([]);
  const [combineObj, setCombainobj] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [formerror, setFormerror] = useState({});
  const [paymentObject, setPaymentObject] = useState({
    donorName: '',
    projectNameByDonor: '',
    emirates: '',
    countryId: '208',
    phone: '',
    email: '',
  });
  const dispatch = useDispatch();
  const updatedCartValue = useSelector((state) => state.updatedCart.updatedCart);
  const COUNTRIES = `${baseURL}/Utilities/GetCountryList`;
  const { loading: countryLoading, error: countryError, value: countryData } = useFetch(COUNTRIES, {}, []);

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getUserData = async () => {
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        if (result) {
          setPaymentObject((prevState) => ({
            ...prevState,
            donorName: result?.userName || '',
            projectNameByDonor: '',
            countryId: result?.countryID?.toString() || '208',
            emirates: result?.emiratesName || '',
            email: result?.email || '',
            phone: result?.mobile || '',
          }));
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const fetchData = useCallback(async () => {
    if (token) {
      try {
        setIsLoading(true);
        setDatanotfound(false);
        const response = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
        if (response) {
          setIsLoading(false);
          setValue(response);
          dispatch(addToCart(response?.data));
          dispatch(updatedCart(true));
        }

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        const idArry = [];
        response?.data.forEach((element) => {
          // idArry.push(element?.projectID);
          //  idArry.push(element?.projectTypeIdInt);
          idArry.push({
            projectID: element?.projectID,
            projectTypeIdInt: element?.projectTypeIdInt,
          });
        });
        if (response?.data.length > 0) {
          getRecodId(idArry, response?.data);
        }
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
        setIsLoading(false);
        setDatanotfound(true);
      }
    }
    if (!token) {
      setDatanotfound(false);
      const storedData = localStorage.getItem('cart');

      setToken(!!localStorage.getItem('token'));
      setCartItems(JSON.parse(storedData));
      if (JSON.parse(storedData) == null) {
        setDatanotfound(true);
      }
      if (JSON.parse(storedData).length == 0) {
        setDatanotfound(true);
      }
    }
  }, [token, epUserID, updatedCart, dispatch]);



  const getRecodId = async (idArry, datavalue) => {
    const newObj = [];
    setIsLoading(true);
    await postAsync('APIClient/ProjectListGUID', idArry)
      .then((response) => {
        setIsLoading(false);
        if (response?.data.length > 0) {
          response?.data?.forEach((element) => {
            datavalue?.forEach((data) => {
              if (data?.projectID === element?.id) {
                newObj.push({ ...element, ...data });
              }
            });
          });
        }
        setCombainobj(newObj);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    if (token) {
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }
    getEmirates();
  }, [updatedCart]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (token) {
      if (epUserID !== null) {
        getUserData();
      }
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }

    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (!role) {
      PageHitCountApi(location.pathname, 0);
    }

    if (role && epUserID != null && epUserID != 0) {
      PageHitCountApi(location.pathname, epUserID);
    }
  }, [epUserID]);

  useEffect(() => {
    if (value && token) {
      setTotalPrice(value?.data?.reduce((acc, item) => acc + parseFloat(item.amount) || 0, 0));
    } else {
      setTotalPrice(cartItems?.reduce((price, item) => price + parseFloat(item.price) || 0, 0));
    }
  }, [value, updatedCartValue, totalPrice, cartItems]);

  const handleDeleteItem = useCallback(
    async (index) => {
      if (token) {
        try {
          if (token) {
            const response = await axios.post(`${baseURL}/Cart/GetCartListByEpUserIdAndIP`, {
              EPUserID: epUserID,
            }); // Update cart items after deletion

            if (response?.data?.statusCode == 204) {
              setDatanotfound(true);
            }
            setValue(response?.data);
            dispatch(addToCart(response?.data.data));
            if (response) {
              dispatch(updatedCart(true));
            }
            if (response?.data?.statusCode == 200) {
              toast.success(t('Item Deleted Successfully'));
              fetchData();
            }
          } else {
            toast.error(t('Failed to delete item'));
          }
        } catch (error) {
          toast.error(t('An error occurred while deleting the item!'));
        }
      } else {
        if (index >= 0 && index < cartItems.length) {
          cartItems.splice(index, 1);
          const updatedData = JSON.stringify(cartItems);
          localStorage.setItem('cart', updatedData);
          dispatch(updatedCart(true));
          toast.success(t('Item Deleted Successfully'));
          if (cartItems?.length <= 0) {
            setDatanotfound(true);
          }
        }
      }
    },
    [cartItems, token, value],
  );

  // Handle Form Value
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPaymentObject((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Create a new array with updated objects value with login
  const updatedArrayOfObjects = combineObj?.map(function (object) {
    const newObj = {
      ...object,
      picture: object?.imagePath,
      moduleId: 1,
      moduleName: 'moduleName',
      itemId: object?.cartID?.toString(),
      projectId: object?.projectID,
      title: object?.titleAr,
      isFixed: true,
      count: 1,
      userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      donorNameByDonor: paymentObject?.donorName,
      projectNameByDonor: object?.titleAr,
      giftAmount: 0,
      recurringAmount: object?.amount,
      paymentType: object?.paymentPeriodID,
    };
    delete newObj.descriptionAr;
    delete newObj.descriptionEnglish;
    delete newObj.id;
    delete newObj.titleAr;
    delete newObj.titleEn;
    delete newObj.isRecurring;
    delete newObj.isContribution;
    delete newObj.isConturbution;
    delete newObj.receivedPercentage;
    delete newObj.paymentPeriodID;
    delete newObj.doc;
    delete newObj.ip;
    delete newObj.projectID;
    delete newObj.projectName;
    delete newObj.timeNow;
    delete newObj.totalAmmount;
    delete newObj.epUserID;
    delete newObj.description;
    delete newObj.date;
    delete newObj.picture;
    return newObj;
  });

  // Create a new array with updated objects value without login
  const updatedArrayOfObjectsData = cartItems?.map(function (object) {
    const newObj = {
      ...object,
      cartID: 0,
      picture: object.imagePath,
      moduleId: 1,
      moduleName: 'moduleName',
      itemId: '0',
      projectId: object.projectGuID || object?.id,
      title: object.titleAr,
      isFixed: true,
      amount: object.price,
      count: 1,
      userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      donorNameByDonor: paymentObject?.donorName,
      projectNameByDonor: object.titleAr,
      giftAmount: 0,
      recurringAmount: object?.price,
      paymentType: object?.paymentPeriodID,
    };
    delete newObj.descriptionAr;
    delete newObj.descriptionEnglish;
    delete newObj.id;
    // delete newObj.titleAr;
    delete newObj.titleEn;
    delete newObj.isRecurring;
    delete newObj.isContribution;
    delete newObj.isConturbution;
    delete newObj.receivedPercentage;
    delete newObj.paymentPeriodID;
    delete newObj.description;
    delete newObj.countryID;
    delete newObj.projectID;
    delete newObj.projectName;
    delete newObj.timeNow;
    delete newObj.totalCost;
    delete newObj.epUserID;
    delete newObj.epUserName;
    delete newObj.generalServiceID;
    delete newObj.projectID;
    delete newObj.projectTypeID;
    delete newObj.referralLink;
    delete newObj.campaignId;
    delete newObj.projectGuID;
    delete newObj.campaignName;
    delete newObj.transactionID;
    delete newObj.price;
    return newObj;
  });

  // final payment object
  const paymentData = {
    donorNameByDonor: paymentObject?.donorName,
    userID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    userIdNumber: token ? epUserID : 0,
    comments: '',
    mobile: paymentObject?.phone,
    email: paymentObject?.email,
    isRecurring: true,
    recuringType: '1',
    afterPaymentReturnPath: '',
    cart: !token ? updatedArrayOfObjectsData : updatedArrayOfObjects,
  };

  const userinfo = z
    .object({
      email: z
        .string()
        .email('Please provide a valid email')
        .refine((value) => value.trim() !== '', {
          message: 'Email is required',
        }),
      phone: z
        .string()
        .min(5, 'Number must contain min 5 digits')
        .max(12, 'Number must contain max  12 digits')
        .refine((value) => value && /[0-9]/.test(value), {
          message: 'Mobile number is required',
        }),
      donorName: z
        .string()
        .min(3, 'Must be 3 or more characters long')
        .max(50, 'Must be 50 characters long')
        .refine((value) => value || /[a-z]/.test(value), 'Donor Name is required')
        .refine((value) => value || /[A-Z]/.test(value), 'Donor Name is required'),
      projectNameByDonor: z
        .string()
        .min(3, 'Must be 3 or more characters long')
        .max(50, 'Must be 50 characters long')
        .refine((value) => value || /[a-z]/.test(value), 'Project Name By Donor is required')
        .refine((value) => value || /[A-Z]/.test(value), 'Project Name By Donor is required'),
      countryId: z.string().refine((value) => value > '0', {
        message: 'Country is required',
      }),
      emirates: z.string().optional(),
    })
    .refine(
      (data) => {
        if (data.countryId === '208' && !data.emirates) {
          return false;
        }
        return true;
      },
      {
        message: 'Emirate is required when country is UAE',
        path: ['emirates'],
      },
    );

  const handlePayment = async (e) => {
    e.preventDefault();

    const userinfoparse = userinfo.safeParse(paymentObject);

    if (!userinfoparse.success) {
      const error = userinfoparse.error;
      let newerror = {};
      for (const issue of error.issues) {
        newerror = { ...newerror, [issue.path]: issue.message };
      }
      return setFormerror(newerror);
    } else {
      if (!token) {
        setIsLoading(true);
        await postAsync(`APIClient/WihtOutLoginCartPaymentRequest`, paymentData)
          .then((response) => {
            localStorage.setItem('isPayment', true);
            window.location.href = response?.paymentPortal;
          })
          .catch((err) => {
            console.log('err responsePayment', err);
          });
      } else {
        await postAsync(`APIClient/CartPaymentRequest`, paymentData)
          .then((response) => {
            localStorage.setItem('isPayment', true);
            window.location.href = response?.paymentPortal;
          })
          .catch((err) => {
            console.log('err responsePayment', err);
          });
      }
    }
  };

  return (
    <>
      {' '}
      <Banners />
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        (!token ? cartItems?.length > 0 : value?.data?.length > 0) && (
          <>
            {' '}
            <div className="h-full px-3 ">
              <div className="py-12  ">
                <div className="max-w-md mx-auto bg-green-50 shadow-lg rounded-lg md:max-w-7xl">
                  <div className="lg:flex ">
                    <div className="w-full p-4 md:px-5 md:py-5">
                      <div className="lg:grid md:grid-cols-2 lg:grid-cols-3 gap-2 ">
                        <div className="col-span-2 space-y-2 px-3 lg:px-9 py-3 lg:py-6 max-h-[800px] overflow-y-auto border-2 rounded-2xl border-customgreen">
                          <h1 className="text-2xl font-semibold text-customgreen">{t('Donation')}</h1>

                          {/* Header for the cart items */}

                          <div className=" overflow-x-auto  shadow-md sm:rounded-lg">
                            <Table className="text-sm text-left rtl:text-right ">
                              <Table.Header className="text-xs text-white whitespace-nowrap items-center rounded-lg  bg-customgreen uppercase ">
                                <Table.Row className="">
                                  <th className={'py-2 px-4 text-white border-b'}>{t('Project Image')}</th>
                                  <th className="py-2 px-4 text-white border-b">{t('Project Title')}</th>
                                  <th className="py-2 px-4 text-white border-b">{t('Project Amount')}</th>
                                </Table.Row>
                              </Table.Header>
                              {/* Iterate over cart items and render each item */}
                              <Table.Body>
                                {!token &&
                                  cartItems?.map((item, index) => (
                                    <AddCartItem
                                      index={index}
                                      title={item.titleAr}
                                      titleEn={item.titleEn}
                                      templateName={item.templateName}
                                      description={item.descriptionAr}
                                      descriptionEn={item.descriptionEnglish}
                                      doc={item.projectImage}
                                      file_Stream={item.imagePath}
                                      handleDeleteItem={handleDeleteItem}
                                      price={item.price}
                                    />
                                  ))}

                                {/* Iterate over cart items and render each item */}
                                {isLoading ? (
                                  <LoadingAnimation />
                                ) : (
                                  token &&
                                  combineObj?.map((item, index) => (
                                    <AddCartItem
                                      index={index}
                                      cartID={item.cartID}
                                      title={item.titleAr}
                                      titleEn={item.titleEn}
                                      description={item.description}
                                      descriptionEn={item.descriptionEnglish}
                                      doc={item.doc}
                                      file_Stream={item.imagePath}
                                      handleDeleteItem={handleDeleteItem}
                                      price={item.amount}
                                      setDatanotfound={setDatanotfound}
                                      sourceType={item.sourceType}
                                      genderNameEn={item.genderNameEn}
                                    />
                                  ))
                                )}
                              </Table.Body>
                            </Table>
                          </div>
                        </div>

                        {/* payment section */}
                        <div className="w-full  rounded-xl py-3 px-2">
                          <h1 className="text-2xl font-semibold  text-customgreen pb-2">{t('Personal Info')} </h1>

                          <form className="w-full">
                            <div className="mb-4">
                              <input
                                placeholder={t('Donor Name')}
                                type="text"
                                id="donorName"
                                className="items-left  w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen"
                                name="donorName"
                                value={paymentObject?.donorName}
                                onChange={(e) => handleOnChange(e)}
                              />
                              {formerror.donorName && <p className="text-red-700">{t(formerror.donorName)}</p>}
                            </div>
                            <div className="mb-4">
                              <input
                                placeholder={t('Project Name By Donor')}
                                type="text"
                                id="projectName"
                                className="w-full  items-start px-4 py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen"
                                name="projectNameByDonor"
                                value={paymentObject?.projectNameByDonor}
                                onChange={(e) => handleOnChange(e)}
                              />
                              {formerror.projectNameByDonor && (
                                <p className="text-red-700">{t(formerror.projectNameByDonor)}</p>
                              )}
                            </div>
                            <div className="mb-4">
                              <select
                                disabled="true"
                                id="country"
                                className="w-full px-4 items-start py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen cursor-not-allowed"
                                name="countryId"
                                value={paymentObject?.countryId}
                                onChange={(e) => handleOnChange(e)}
                              >
                                {countryData?.data?.map(
                                  (item) =>
                                    item.countryCode !== 0 && (
                                      <option key={item.countryID} value={item.countryID}>
                                        {isActive
                                          ? `${item.ar_SA} (${item.countryCode})`
                                          : `${item.countryName} (${item.countryCode})`}
                                      </option>
                                    ),
                                )}
                              </select>
                            </div>

                            {paymentObject?.countryId == 208 && (
                              <>
                                <div className="mb-4">
                                  <select
                                    id="emirates"
                                    className="w-full px-4   items-start py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen"
                                    name="emirates"
                                    value={paymentObject.emirates}
                                    onChange={(e) => handleOnChange(e)}
                                  >
                                    <option value={''}>{paymentObject.emirates || t('SELECT EMIRATES')}</option>
                                    {emiratesAPIData?.map((item) => {
                                      return (
                                        <option key={item.emiratesID} value={item.emiratesID}>
                                          {t(isActive ? item?.ar_SA : item?.en_US)}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  {formerror.emirates && <p className="text-red-700">{t(formerror.emirates)}</p>}
                                </div>
                              </>
                            )}
                            <div className="mb-4 gap-3 ">
                              <input
                                placeholder={t('Mobile')}
                                type="text"
                                maxLength={13}
                                id="phoneNumber"
                                className="w-full px-4  py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen"
                                name="phone"
                                value={paymentObject?.phone}
                                onChange={(e) => handleOnChange(e)}
                                onInput={(event) => {
                                  const { value } = event.target;
                                  // const regex = /^\d+(\.\d{0,2})?$/;
                                  const regex = /^\+?\d*$/;
                                  if (regex.test(value)) {
                                  } else {
                                    event.target.value = value.slice(0, -1);
                                  }
                                }}
                              />
                              {formerror.phone && <p className="text-red-700">{t(formerror.phone)}</p>}
                            </div>

                            <div className="mb-4">
                              <input
                                placeholder={t('Email')}
                                type="email"
                                id="email"
                                className="w-full px-4  items-start py-2 border border-gray-300 rounded-md focus:ring-customgreen hover:focus:border-customgreen"
                                name="email"
                                value={paymentObject?.email}
                                onChange={(e) => handleOnChange(e)}
                              />
                              {formerror.email && <p className="text-red-700">{t(formerror.email)}</p>}
                            </div>
                            <div className="mb-4 flex justify-between items-center px-2 py-2  border border-gray-300 rounded-md">
                              <h1 className="text-lg font-semibold ">{t('Total Amount')}</h1>
                              <span className="text-lg text-red-600 font-bold">
                                {totalPrice.toFixed(2)} {t('AED')}
                              </span>
                            </div>
                            <div className="flex  mb-4 p-4 justify-center align-middle">
                              <button className="mr-5" onClick={handlePayment}>
                                <img src="/assets/images/cardPaymentDouble.png" alt="card pay double" />
                              </button>
                              <button className="mr-5" onClick={handlePayment}>
                                <img src="/assets/images/applePay.png" alt="apple pay" />
                              </button>
                              <button className="mr-5" onClick={handlePayment}>
                                <img src="/assets/images/samsungPay.png" alt="samsung pay" />
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      )}
      <div className="  flex justify-center align-middle items-center ">
        {datanotfound && (
          <div className="">
            {/* <DataNotFound /> */}
            <img
              src={isActive ? '/assets/images/emptyCartAr.png' : '/assets/images/emptyCartEn.png'}
              alt="cart is empty"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(AddCart);
